export default __webpack_public_path__ + "static/media/Hand-wraps of the Haunter in the Dark.a1a0516f.jpg";